import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SUPPORT_EMAIL, SUPPORT_PHONE } from '../api/config';
import { PageShell } from '../components/Layout';
import { IconPhone } from '../components/Icons';

export default function ContactPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <PageShell>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10 md:py-14">
        <h1 className="page-title">Contact</h1>
        <p className="text-ink/60 mt-3">Questions about your search or payment? Reach us directly.</p>

        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          <a href={`tel:${SUPPORT_PHONE}`} className="block bg-white border-2 border-forest p-6 hover:shadow-stamp transition-shadow group">
            <IconPhone className="w-6 h-6 text-clay mb-3" />
            <p className="text-xs font-bold uppercase tracking-wider text-ink/50">Phone</p>
            <p className="font-serif text-xl text-forest mt-1 group-hover:text-clay transition-colors">{SUPPORT_PHONE}</p>
          </a>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="block bg-white border-2 border-forest p-6 hover:shadow-stamp transition-shadow group">
            <p className="text-xs font-bold uppercase tracking-wider text-ink/50 mb-3">Email</p>
            <p className="font-semibold text-forest break-all group-hover:text-clay transition-colors">{SUPPORT_EMAIL}</p>
          </a>
        </div>

        <div className="mt-10">
          <Link to="/" className="btn-outline">← Back to search</Link>
        </div>
      </div>
    </PageShell>
  );
}
